import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

export const AI_COMPANION_WARNING_TYPES = {
	CONVERSATION_LOAD_ERROR: 'conversation_load_error',
	ERROR: 'error',
	MESSAGE_LOAD_ERROR: 'message_load_error',
	TIMEOUT: 'timeout',
} as const;

type WarningType = (typeof AI_COMPANION_WARNING_TYPES)[keyof typeof AI_COMPANION_WARNING_TYPES];

interface TriggerAiCompanionWarningShownEventParams {
	warningType: WarningType;
}

export const triggerAiCompanionUnsuccessfulMessageShownEvent = ({
	warningType,
}: TriggerAiCompanionWarningShownEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: warningType },
		name: 'dlr_ai_companion_unsuccessful_message_shown',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
